export const groupByActionsOptions = [
  { id: 1, label: 'mean' },
  { id: 2, label: 'max' },
  { id: 3, label: 'min' },
  { id: 4, label: 'sum' },
  { id: 5, label: 'count' }
];
